<template>
    <div class="widget">
        <SvgSprite />
        <div class="sailing-updates">
            <ul v-if="routes" class="sailing-updates__tabs">
                <li v-for="(route, index) in routes" :key="index">
                    <VRadio v-model="active" name="route" :id="route.id" :value="route.id">
                        {{ route.routeName }}
                    </VRadio>
                </li>
            </ul>
            <VCard unelevated bordered>
                <SailingUpdates :selectedRoute="active" />
            </VCard>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { VCard, VRadio } from "v-ferry-components";
import { ref, watch } from "vue";
import SailingUpdates from "./components/SailingUpdates.vue";
import useRoutesQuery from "./composables/useRoutesQuery";
import SvgSprite from "@/components/icons/SvgSprite.vue";
import "@/css/style.scss";

const { data: routes } = useRoutesQuery();

const active = ref(1);

watch(routes, (c) => {
    if (c) {
        active.value = c[0].id;
    }
});
</script>

<style lang="scss" scoped>
.widget {
    --v-card-br: 0 5px 5px 5px;
}

.sailing-updates {
    display: flex;
    flex-direction: column;
    width: 100%;
    color: var(--c-primary);

    &__tabs {
        display: flex;
        gap: 5px;
        flex: 100%;
        margin-bottom: 0;
        padding-left: 0;

        :deep(input[type="radio"]) {
            + label {
                border-radius: 5px 5px 0 0;
                padding: 10px 15px;
                background-color: var(--c-secondary);
                color: white;

                &:hover {
                    background-color: darken(#68aee0, 10%);
                }

                &::before {
                    display: none;
                }
            }

            &:checked {
                + label {
                    background-color: var(--c-primary);
                    &:hover {
                        background-color: darken(#00529a, 10%);
                    }

                    &::after {
                        display: none;
                    }
                }
            }
        }
    }
    &__content {
        width: 100%;
        padding: 20px;
    }
}
</style>
